import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import LeaveCreateForm from './LeaveCreateForm';

export default function LeaveRequestDialog({ open, onClose, draft, onCreated, onRefresh, onDraftChange }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>New Leave Request</DialogTitle>
      <DialogContent dividers>
        <LeaveCreateForm
          draft={draft}
          onDraftChange={onDraftChange}
          onCreated={() => { if (onCreated) onCreated(); if (onClose) onClose(); }}
          onRefresh={onRefresh}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}

